export default __webpack_public_path__ + "images/notif_icon_large_abec7ee.png";